import {useState, useEffect,useContext, useMemo} from 'react';
import DialogTitleDefault from '../default/DialogTitleDefault';
import {toast} from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import EditIcon from '@mui/icons-material/Edit';
import { SocketContext } from '../../context/SocketContext';
import { ButtonBasic, DateSingle, InputEditQuill, SelectEstadoReprogramar, SelectMotivoBajaTk, SelectMotivoTicket, SelectNivelAdmTicket, SelectOtrosProveedores, SelectPrioridadTkNubicom, SelectStageTicket, SelectSubMotivoBaja, SelectSubTipoTicket, SelectTipoTicket } from '../../components';
import { Box, Divider, Grid, TextField, Typography, useTheme } from '@mui/material';
import TicketService from '../../services/tickets.service';
import FechaFunction from '../../function/FechaFunction';
import usePermisos from '../../hooks/usePermisos';
import { set } from 'date-fns';


function ModalEditTicketNubicom({show, hideModal, onGuardar,item,trato,linkContratoSoft}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const permisos = usePermisos();
    const { sockets } = useContext( SocketContext );
    const [motivoReprogramado, setMotivoReprogramado] = useState(null);
    const [arrSubMotivoBaja, setArrSubMotivoBaja] = useState([]);
    const [subMotivoBajaId, setSubMotivoBaja] = useState(null);
    const [formAll, setFormAll] = useState({
        titulo_tk: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        motivo_tk: {
            texto: null,
            textoErr: 'El motivo es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        fechavencimiento_tk: {
            texto: null,
            textoErr: 'La fecha de vencimiento es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        prioridad_tk: {
            texto: null,
            textoErr: 'La prioridad es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        stageTicket_tk: {
            texto: null,
            textoErr: 'La etapa es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        tipoTicketId_tk: {
            texto: null,
            textoErr: 'El tipo de ticket es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        subTipoTicketId_tk: {
            texto: null,
            textoErr: 'El sub-tipo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        nivelAdmTkId_tk: {
            texto: null,
            textoErr: 'El nivel administrativo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        motivoBajaTk_tk: {
            texto: null,
            textoErr: 'El motivo de baja es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        cuerpo_tk: {
            texto: null,
            textoErr: 'El cuerpo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        motivoBajaProveedorTk_tk: {
            texto: null,
            textoErr: 'El motivo de baja proveedor es requerido',
            estadoErr: false,
            tipo: 'string'
        }
    });

    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && (input !== 'nivelAdmTkId_tk' && input !== 'motivoBajaTk_tk')){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() =>{
        if(arrSubMotivoBaja?.length > 0 && !subMotivoBajaId){
            toast.error('Debe seleccionar un Sub-Motivo de baja.', {
                position: "top-right",
                autoClose: 2500,
                pauseOnHover: false,
            });
        }else{
            const form = {
                propertys: 'nubicom',
                id_tk: item.id_tk,
                createdEmp_tk: 'NUBICOM',
            };
            if(subMotivoBajaId){
                form.subMotivoBajaId_tk = subMotivoBajaId;
            }
            let isOk = false;
            setIsLoading(true);
            const inputRequired = ['titulo_tk','cuerpo_tk','motivo_tk','fechavencimiento_tk','prioridad_tk','stageTicket_tk','tipoTicketId_tk','subTipoTicketId_tk']
            if(formAll?.stageTicket_tk?.texto === 'Reprogramar' && !motivoReprogramado){
                toast.error('Debe seleccionar un motivo a reprogramar.', {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                setIsLoading(false);
                return '';
            }
            if((formAll?.motivoBajaTk_tk?.texto && formAll?.motivoBajaTk_tk?.texto?.toString()?.length > 0)){
                const motivoBajaValue = Number(formAll?.motivoBajaTk_tk?.texto);
                if([1, 8, 9, 10].includes(motivoBajaValue)){
                    inputRequired.push('motivoBajaProveedorTk_tk')
                }
            }
            const propertyNames = Object.keys(formAll);
            await Promise.resolve(
            propertyNames.forEach((name)=>{
                if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
                    form[name] = formAll[name].texto
                }else{
                    if(inputRequired.includes(name)){
                        isOk = true;
                        onChangeFormSetError(name)
                    }
                }
            }))
            if(!isOk){
                if((trato && trato?.id_t && trato?.estadoServicio_t !== 'INSTALADO' && !trato?.isDeleted_t) && form.stageTicket_tk === 'Reprogramar'){
                    form.idPreservicio = trato?.id_t;
                    form.estadoReprogramado = motivoReprogramado;
                }
                if(form.stageTicket_tk === 'Reprogramar' && motivoReprogramado){
                    form.estadoReprogramado_tk = motivoReprogramado;
                }
                if(linkContratoSoft?.servicioId){
                    form.idServicioSoft = linkContratoSoft?.servicioId;
                }
                TicketService.update(form).then(()=>{
                    sockets?.emit( 'ticketNubiRefresh', `ticket-nubi-${item?.id_tk}` );
                    if(onGuardar){
                        onGuardar();
                    }
                    hideModal();
                })
                .finally(() => {
                    setIsLoading(false);
                });
            }else{
                setIsLoading(false)
            }
        }
    }
    const cambiarFecha = (date) =>{
        if(!date){
            date = 0;
        }
        if(formAll?.subTipoTicketId_tk?.texto !== item?.subTipoTicketId_tk){
            const newDate = FechaFunction.addDaysDate(new Date(),date)
            onChangeForm(newDate, 'fechavencimiento_tk')
        }else{
            onChangeForm(item?.fechavencimiento_tk, 'fechavencimiento_tk')
        }
    }

    useEffect(() => {
        if(item){
            onChangeForm(item?.tipoTicketId_tk, 'tipoTicketId_tk')
            onChangeForm(item?.subTipoTicketId_tk, 'subTipoTicketId_tk')
            onChangeForm(item?.nivelAdmTkId_tk, 'nivelAdmTkId_tk')
            onChangeForm(item?.prioridad_tk, 'prioridad_tk')
            onChangeForm(item?.motivoBajaTk_tk, 'motivoBajaTk_tk')
            onChangeForm(item?.motivo_tk, 'motivo_tk');
            onChangeForm(item?.titulo_tk,'titulo_tk')
            onChangeForm(item?.fechavencimiento_tk, 'fechavencimiento_tk')
            onChangeForm(item?.stageTicket_tk, 'stageTicket_tk');
            onChangeForm(item?.motivoBajaProveedorTk_tk, 'motivoBajaProveedorTk_tk');
            setTimeout(() => {
                onChangeForm(item?.cuerpo_tk, 'cuerpo_tk');
            }, 100);
            if(item?.estadoReprogramado_tk){
                setMotivoReprogramado(item?.estadoReprogramado_tk)
            }
        }
    }, [item])

    const styleInputHeight = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 15
        },
        '& fieldset': {
            borderRadius: 2,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            height: 45
        },
        '& label':{
            marginTop: -0.5,
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                height: 45,
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                color: isDarkMode ? '#e0e0e0' : '#000'
            },
            '&:hover':{
                border: 1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#4a5a72' : 'gray',
                height: 40
            },
            '&.Mui-focused': {
                '&:hover':{
                border:0,
                height: 40
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 40
        }
    }), [isDarkMode])

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flex: 1
                    }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #0364ff 0%, #0284ff 100%)',
                            borderRadius: 1.5,
                            p: 0.75,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(3, 100, 255, 0.15)'
                        }}>
                            <EditIcon sx={{ color: '#fff', fontSize: 22 }} />
                        </Box>
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.25, flex: 1}}>
                            <Typography sx={{
                                color: isDarkMode ? '#90caf9' : '#0364ff',
                                fontWeight: 700,
                                fontSize: '1.05rem',
                                lineHeight: 1.1
                            }}>
                                Modificar Ticket #{item?.id_tk}
                            </Typography>
                            <Typography sx={{
                                color: isDarkMode ? '#b0bec5' : '#64748b',
                                fontSize: '0.75rem',
                                fontWeight: 500,
                                lineHeight: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {item?.titulo_tk}
                            </Typography>
                        </Box>
                    </Box>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e5e7eb'}} />
                <DialogContent className='side'>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={5} mt={2.5}>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                label='Titulo'
                                sx={styleInputHeight}
                                value={formAll.titulo_tk.texto || ''}
                                onChange={(e)=>onChangeForm(e.target.value,'titulo_tk')}
                                InputLabelProps={{shrink: !!formAll.titulo_tk.texto}}
                                error={formAll.titulo_tk.estadoErr}
                                helperText={formAll.titulo_tk.estadoErr && formAll.titulo_tk.textoErr}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Prioridad</Typography>
                            <SelectPrioridadTkNubicom
                                isInvalid={formAll.prioridad_tk.estadoErr}
                                value={formAll.prioridad_tk.texto}
                                onChange={(e)=>onChangeForm(e.value,'prioridad_tk')}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Motivo del Ticket</Typography>
                            <SelectMotivoTicket
                                isInvalid={formAll.motivo_tk.estadoErr}
                                value={formAll.motivo_tk.texto}
                                emp='nubicom'
                                onChange={(opt)=>{
                                    onChangeForm(opt.value,'motivo_tk')
                                    onChangeForm(opt.tipoTicket,'tipoTicketId_tk')
                                    onChangeForm(opt.subTipoTicket,'subTipoTicketId_tk')
                                    onChangeForm(opt.nivelAdm,'nivelAdmTkId_tk')
                                    onChangeForm(opt.motivoBaja,'motivoBajaTk_tk')
                                    cambiarFecha(opt.dayResolucion)
                                }}
                            />
                            {formAll.motivo_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.motivo_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Tipo del Ticket</Typography>
                            <SelectTipoTicket
                                value={formAll.tipoTicketId_tk.texto}
                                onChange={(opt)=>onChangeForm(opt.value,'tipoTicketId_tk')}
                            />
                            {formAll.tipoTicketId_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.tipoTicketId_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Sub-Tipo</Typography>
                            <SelectSubTipoTicket
                                id="subTipoTicket"
                                name="subTipoTicket"
                                tipoTicket={formAll.tipoTicketId_tk.texto}
                                value={formAll.subTipoTicketId_tk.texto}
                                isDisabled={!formAll.tipoTicketId_tk.texto}
                                onChange={(opt)=>{
                                    onChangeForm(opt.value, 'subTipoTicketId_tk')
                                    cambiarFecha(opt.resolucion)
                                }}
                            />
                            {formAll.subTipoTicketId_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.subTipoTicketId_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Nivel Administrativo</Typography>
                            <SelectNivelAdmTicket
                                id="nivelAdmTk"
                                name="nivelAdmTk"
                                subTipoTicket={formAll.subTipoTicketId_tk.texto}
                                value={formAll.nivelAdmTkId_tk.texto}
                                isDisabled={!formAll.subTipoTicketId_tk.texto}
                                onChange={(opt)=>onChangeForm(opt?.value || null, 'nivelAdmTkId_tk')}
                                isClearable
                            />
                            {formAll.nivelAdmTkId_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.nivelAdmTkId_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={4} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Motivo de Baja</Typography>
                            <SelectMotivoBajaTk
                                id="motivoBajaTk"
                                name="motivoBajaTk"
                                isDisabled={formAll.nivelAdmTkId_tk.texto !== 10}
                                nivelAdmTk={4}
                                value={formAll.motivoBajaTk_tk.texto}
                                onChange={(opt)=>{
                                    onChangeForm(opt?.value || null, 'motivoBajaTk_tk');
                                    setArrSubMotivoBaja(opt?.arrSubMotivoBaja || [])
                                    setSubMotivoBaja(null);
                                    onChangeForm(null,'motivoBajaProveedorTk_tk')
                                }}
                                isClearable
                            />
                            {formAll.motivoBajaTk_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.motivoBajaTk_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        {arrSubMotivoBaja?.length > 0 && (
                            <Grid item xs={12} md={4} mt={0.5}>
                                <Box sx={{display: 'flex', alignItems: 'start', justifyContent: 'center',flexDirection: 'column',width: '100%'}}>
                                    <Box sx={{width: '100%',p:0}}>
                                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',marginTop:0}}>Sub-Motivo de baja</Typography>
                                        <SelectSubMotivoBaja
                                            value={subMotivoBajaId}
                                            onChange={(opt)=>setSubMotivoBaja(opt.value)}
                                            filterId={arrSubMotivoBaja}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                        {formAll?.motivoBajaTk_tk?.texto && [1, 8, 9, 10].includes(Number(formAll?.motivoBajaTk_tk?.texto)) &&(
                            <Grid item xs={12} sm={6} md={4} mt={0.5}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Proveedor</Typography>
                                <SelectOtrosProveedores
                                    value={formAll?.motivoBajaProveedorTk_tk?.texto}
                                    isInvalid={formAll?.motivoBajaProveedorTk_tk?.estadoErr}
                                    onChange={(opt) =>{
                                        onChangeForm(opt.value,'motivoBajaProveedorTk_tk')
                                    }}
                                />
                                {formAll?.motivoBajaProveedorTk_tk?.estadoErr && (
                                    <Typography sx={{color: 'red',fontSize:10}}>Campo obligatorio</Typography>
                                )}
                            </Grid>
                        )}
                        <Grid item xs={12} md={4} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Etapa del Ticket</Typography>
                            <SelectStageTicket
                                id="stageTicket"
                                name="stageTicket"
                                notClose
                                value={formAll.stageTicket_tk.texto}
                                onChange={(opt)=>{
                                    setMotivoReprogramado(null);
                                    onChangeForm(opt.value, 'stageTicket_tk');
                                }}
                            />
                            {formAll.stageTicket_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.stageTicket_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        { formAll.stageTicket_tk.texto === 'Reprogramar' &&(
                            <Grid item xs={12} md={4} mt={0.5}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Motivo a Reprogramar</Typography>
                                <SelectEstadoReprogramar
                                    id="motivoReprogramado"
                                    name="motivoReprogramado"
                                    notClose
                                    value={motivoReprogramado}
                                    onChange={(opt)=>setMotivoReprogramado(opt.value)}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={4}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Fecha de vencimiento</Typography>
                            <DateSingle
                                id="vtoTicket"
                                value={formAll.fechavencimiento_tk.texto}
                                minDate={new Date()}
                                onChange={(value)=>onChangeForm(value, 'fechavencimiento_tk')}
                                isDisabled={!permisos['fec_vencimiento_nubi']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputEditQuill
                                template={formAll.cuerpo_tk.texto || ''}
                                onChangeText={(e)=>onChangeForm(e,'cuerpo_tk')}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray',mt:2}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        variant='wk'
                        color='nextStep'
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}

export default ModalEditTicketNubicom;
